var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 364.6,
    height: 477.96,
    viewBox: "0 0 364.6 477.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #414042;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136,6.17V135.54c.24,3.48,1.33,23.36-10.63,40.31-11.42,16.2-26.51,18-29.53,18.33H5.2",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136,484.13V354.76c.24-3.48,1.33-23.37-10.63-40.31-11.42-16.2-26.51-18-29.53-18.33H5.2",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239,6.17V135.54c-.24,3.48-1.33,23.36,10.63,40.31,11.42,16.2,26.51,18,29.53,18.33H369.8",
    transform: "translate(-5.2 -6.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239,484.13V354.76c-.24-3.48-1.33-23.37,10.63-40.31,11.42-16.2,26.51-18,29.53-18.33H369.8",
    transform: "translate(-5.2 -6.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadD);
export default __webpack_public_path__ + "static/media/road-D.e36e95f7d624a45f8f8282f358905c62.svg";
export { ForwardRef as ReactComponent };